import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { TypeIncidentDto } from 'src/api/models';
import { ControlPanelStore } from 'src/states/control-panel.store';

@Component({
  selector: 'app-type-incident',
  templateUrl: './type-incident.component.html',
  styleUrls: ['./type-incident.component.css']
})
export class TypeIncidentComponent implements OnInit, OnDestroy {

  @Select(ControlPanelStore.typesIncidents$) typesIncidents$: Observable<TypeIncidentDto[]>;

  @Input() public typeIncidentId: number;

  TypeIncidentInComponent: TypeIncidentDto;

  p: Subscription;

  constructor() { }

  ngOnInit(): void {
    this.p = this.typesIncidents$.subscribe(res => {
      if (res != null) {
        let ti = res.filter(p => p.Id == this.typeIncidentId);
        this.TypeIncidentInComponent = ti.length == 1 ? ti[0] : { Designation: null };
      }
    });
  }

  ngOnDestroy() {
    this.p?.unsubscribe();
  }
}
